import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Pathurl from "../Class/Pathurl.json";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ConfigETC from "../Class/ConfigETC.json";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import {
  Class_ETC_MsgError,
  Class_ETC_MsgSuccess,
  Class_ETC_Warning,
  Class_ETC_Encrypt,
  Class_ETC_SessionTimeOut
} from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import { Link } from "react-router-dom";
import PaginationActions from "../PartialView/PaginationActions";
import { CP_CheckPermission } from "../Class/Class_Permission";
import { customStylesSelect } from "../Class/Class_Etc"
/* 
  Create By Kai : 26-JULY-2023 
  Edit By POOM : 07/09/2023 เพิ่ม กดปุ่ม enter คีย์บอร์ด แล้วค้นหาได้เหมือนกดปุ่ม search 
  Edit By POOM : 13/05/2024  เวลา return API  ให้เช็คว่าถ้า status_ID === 2  ให้เด้ง SessionTimeOut ทันที
	

  Edit BY POOM : 20-05-2024 
    - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
	

*/

function M_project_search() {
  
  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const [isPermissionview, setIsPermissionview] = useState(false);
  const [isPermissionEdit, setIsPermissionEdit] = useState(false);
  const [isPermissionDel, setIsPermissionDel] = useState(false);
  const [isPermissionAdd, setIsPermissionAdd] = useState(false);
  const [isPermissionViewAll, setIsPermissionViewAll] = useState(false);
  const [isPermissionOverall, setIsPermissionOverall] = useState(false);

  const pro_status = [
    { value: "-1", label: ConfigETC.ddl_All },
    { value: "1", label: "active" },
    { value: "0", label: "In-active" },
  ];

  const pro_is_close = [
    { value: "-1", label: ConfigETC.ddl_All },
    { value: "1", label: "Open" },
    { value: "0", label: "Close" },
  ];

  const animatedComponents = makeAnimated();
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isShowmsg , setIsShowmsg] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [isSearch, setIsSearch] = useState(false);
  const [listcus, setListcus] = useState([""]);
  const [isAllChecked, setIsAllChecked] = useState(false);

  const [_scus, set_Scus] = useState([]);
  const [_sstatus, set_Sstatus] = useState([]);
  const [_sOC, set_SOC] = useState([]);
  const [listdata, setListdata] = useState([]);
  const [ActEdit] = useState(Class_ETC_Encrypt("Edit"));
  const [ActAdd] = useState(Class_ETC_Encrypt("Add"));

  const [page, setPage] = useState(0);
  // eslint-disable-next-line
  const [rowsPerPage, setRowsPerPage] = useState(ConfigETC.rowsPerPage); //

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
  };

  useEffect(() => {
    if (isFirst === true) {
      let ckpermission = CP_CheckPermission(
        "main",
        ["projects_view"],
        false,
        true
      );
      if (ckpermission === true) {
        setIsPermissionview(ckpermission);
        setIsPermissionEdit(
          CP_CheckPermission("main", ["projects_edit"], false, false)
        );
        setIsPermissionDel(
          CP_CheckPermission("main", ["projects_delete"], false, false)
        );
        setIsPermissionAdd(
          CP_CheckPermission("main", ["projects_add"], false, false)
        );
        setIsPermissionViewAll(
          CP_CheckPermission("main", ["projects_view_all"], false, false)
        );
        setIsPermissionOverall(
          CP_CheckPermission("main", ["projects_overview"], false, false)
        );

        GetConfig();

        if (isLoadedConfigData === true) {
          BindDDL();
          document.getElementById("hd_SelectStatus").value = "-1";
          document.getElementById("hd_SelectSOC").value = "-1";
          setIsSearch(true);

          BindList(true, function () {
            setIsFirst(false);
            setIsLoadProgress(false);
          });
        }
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);


  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      document.getElementById("btn_Search").click();
    }
  };


  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function BindDDL() {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        cus_status: "-1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Customer_Getlist",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          const arr = [];
          json.data.map((en) => {
            return arr.push({ value: en.cus_id, label: en.cus_name });
          });
          setListcus(arr);
          setIsLoadProgress(false);
        } else {
          setListcus([]);
          setIsLoadProgress(false);
        }
      }
      else
      {
        setListcus([]);
        setIsLoadProgress(false);
      }
    } catch {
      setListcus([]);
      setIsLoadProgress(false);
    }
  }

  function onclickSearch() {
    setIsSearch(true);
    setIsLoadProgress(true);
    
    //setIsAllChecked(true);


    BindList(true, function () {
      setIsLoadProgress(false);
    });
  }

  function onChageSelectStatus(e) {
    document.getElementById("hd_SelectStatus").value =
      e !== null ? e.value : "-1";
    //console.log(document.getElementById("hd_SelectStatus").value);
    set_Sstatus(e);
  }

  function onChageSelectOC(e) {
    document.getElementById("hd_SelectSOC").value = e !== null ? e.value : "-1";

    set_SOC(e);
  }

  function onclickReset() {
    set_Scus([]);
    set_Sstatus([]);
    set_SOC([]);
    setIsAllChecked(false);
    document.getElementById("txt_pro_search_text").value = "";
    setIsSearch(false);
  }

  async function BindList(isSearch = true, _callback) {
    try {
      let scus = "";
      if (_scus.length > 0) {
        for (let i = 0; i < _scus.length; i++) {
          scus = scus + (scus === "" ? "" : ",") + _scus[i].value;
        }
      }

      let token = "";
      let isCheckAll = "0";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");

      isAllChecked ? (isCheckAll = "1") : (isCheckAll = "0");
      setIsShowmsg(isAllChecked);

      var raw = JSON.stringify({
        cus_id_list: scus,
        pro_status: document.getElementById("hd_SelectStatus").value,
        pro_is_close: document.getElementById("hd_SelectSOC").value,
        pro_search_text: document
          .getElementById("txt_pro_search_text")
          .value.trim(),
        pro_search_all: isCheckAll,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_GetSearch",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          if (isSearch) {
            setPage(0);
          } else {
            if (rowsPerPage * (page + 1) > json.total_Data) {
              let pagenow = Math.ceil(json.total_Data / rowsPerPage);
              setPage(pagenow === 0 ? 0 : pagenow - 1);
            }
          }
          setListdata(json.data);
          if (_callback != null) {
            _callback();
          }
        } else {
          setPage(0);
          setListdata([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      }
      else
      {
        setPage(0);
        setListdata([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      setPage(0);
      if (_callback != null) {
        _callback();
      }
    }
  }

  function onclick_DelProject(pro_id) {
    document.getElementById("hd_iddel").value = pro_id;
    Class_ETC_Warning(MsgDescription.CFM002, DelProject);
  }

  async function DelProject() {
    setIsLoadProgress(true);
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: document.getElementById("hd_iddel").value.trim(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_Del",
        requestOptions
      );
      const json = await response.json();

      if (json.status_ID === 1) {
        BindList(false, function () {
          setIsLoadProgress(false);
          Class_ETC_MsgSuccess(MsgDescription.CFM003, null);
        });
      }
      else if (json.status_ID === 2) 
      {
        Class_ETC_SessionTimeOut();
      } 
      else {
        setIsLoadProgress(false);
        Class_ETC_MsgError(json.status_Desc, null);
      }
    } catch {
      setIsLoadProgress(false);
      Class_ETC_MsgError(MsgDescription.ERR003, null);
    }
  }

  const onChange_CheckboxAllProject = (e) => {
    const { checked } = e.target;

    setIsAllChecked(checked);
  };

  return (
    <>
      <Helmet>
        <title>Project</title>
      </Helmet>
      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      {/* Content Wrapper. Contains page content */}
      <div className="content-wrapper">
        {/* Content Header (Page header) */}
        <div className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div>
                  <div className="text-center">
                    {" "}
                    <h1>
                      <i className="far fa-building" /> Projects
                    </h1>
                  </div>
                  <div className="search-icon float-right">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-toggle="collapse"
                      href="#collapseOne"
                    >
                      <i className="fas fa-filter" /> Filter
                    </button>
                  </div>
                </div>
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
            <div className="row" id="accordion">
              <div className="col-md-10 offset-md-1">
                <div
                  className="collapse show"
                  id="collapseOne"
                  data-parent="#accordion"
                >
                  <div className="row m-0">
                    <div className="col-lg-8 col-8">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">Customer</label>
                        <Select
                          closeMenuOnSelect={false}
                          components={animatedComponents}
                          placeholder={ConfigETC.ddl_All}
                          isMulti
                          value={_scus}
                          options={listcus}
                          menuPortalTarget={document.body}
                          onChange={(e) => set_Scus(e)}
                         
                         //styles={{
                            //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          //}}
                          styles={customStylesSelect}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-4">
                      <div className="form-group ">
                        <label className="text-small p-0 m-0">Status</label>
                        <Select
                          options={pro_status}
                          placeholder={ConfigETC.ddl_All}
                          isClearable={true}
                          menuPortalTarget={document.body}
                          value={_sstatus}
                          onChange={(e) => onChageSelectStatus(e)}
                          //styles={{
                            //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          //}}
                          styles={customStylesSelect}
                        />
                        <input type="hidden" id="hd_SelectStatus"></input>
                      </div>
                    </div>
                    <div className="col-lg-3 col-6 d-none">
                      <div className="form-group">
                        <label className="text-small p-0 m-0">
                          Open/Closed
                        </label>
                        <Select
                          options={pro_is_close}
                          placeholder={ConfigETC.ddl_All}
                          isClearable={true}
                          menuPortalTarget={document.body}
                          value={_sOC}
                          onChange={(e) => onChageSelectOC(e)}
                          //styles={{
                            //  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          //}}
                          styles={customStylesSelect}
                        />
                        <input type="hidden" id="hd_SelectSOC"></input>
                      </div>
                    </div>
                  </div>
                  <div className="row m-0">
                    <div className="col-lg-8 col-12">
                      <div className="form-group">
                        <input
                          id="txt_pro_search_text"
                          type="search"
                          className="form-control "
                          placeholder="Search by Project name "
                        />
                      </div>
                    </div>
                    {isPermissionViewAll && (<div className="col-lg-2 col-12">
                      <div className="form-group">
                        <span className="icheck-primary d-inline">
                          <input
                            id="chk_show_all_project"
                            type="checkbox"
                            className="form-check-input"
                            checked={isAllChecked}
                            onChange={onChange_CheckboxAllProject}
                          />
                          <label
                            htmlFor="chk_show_all_project"
                            className="text-small p-0 m-0"
                          >
                            Show all project(s)
                          </label>
                        </span>
                      </div>
                    </div>
                    )}
                    
                    <div className="col-lg-2 col-12 ">
                      <div className="form-group m-0">
                        <div className="card-tools">
                          <button
                            type="button"
                            id="btn_Search"
                            className="btn btn-primary btn-sm"
                            onClick={onclickSearch}
                          >
                            <i className="fas fa-search" /> Search
                          </button>
                          {" "}
                          <button
                            type="button"
                            className="btn btn-default btn-sm"
                            onClick={onclickReset}
                          >
                            <i className="fas fa-times" /> reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* /.container-fluid */}
        </div>
        {/* /.content-header */}
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            {/* Show Result */}
            {isSearch && (
              <>
                <div className="row">
                  <div className="col-md-12 ">
                    {/* SELECT2 EXAMPLE */}
                    <div className="card shadow table-responsive p-0">
                      <div className="card-header ">
                        <h3 className="card-title">
                          Result <small> ({listdata.length} items {(isShowmsg === true ? "" : " , Show only projects with our name on them.")})</small>
                        </h3>
                        {/* Finish Show Result */}
                        {isPermissionAdd === true && (
                           <div className="float-right">
                                <Link
                                  to={"../" + Pathurl.m_project_ae}
                                  state={{ proid: Class_ETC_Encrypt("-1"), act: ActAdd }}
                                  className="btn btn-primary btn-sm float-right fix-at-top"
                                >
                                  <i className="fa fa-plus" /> New Project
                                </Link>
                             
                            </div>
                          )}
                          {/* /.row (main row) */}
                       
                      </div>
                      <div className="card-body table-responsive p-0">
                        <input type="hidden" id="hd_iddel"></input>
                        <TableContainer>
                          <Table
                            stickyHeader
                            aria-label="sticky table"
                            className="table table-head-fixed  table-hover"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell width={"3%"} align={"left"}>
                                  <b>#</b>
                                </TableCell>
                                <TableCell width={"15%"} align={"left"}>
                                  <b>Name</b>
                                </TableCell>
                                <TableCell width={"15%"} align={"left"}>
                                  <b>Customer</b>
                                </TableCell>
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Organization</b>
                                </TableCell>
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Task</b>
                                </TableCell>
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Work Time</b>
                                </TableCell>

                                {isSVOT &&
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Over Time</b>
                                </TableCell>
                                }
                                
                                <TableCell width={"10%"} align={"left"}>
                                  <b>Expenses</b>
                                </TableCell>
                                <TableCell width={"10%"} align={"right"}>
                                  &nbsp;
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(listdata.length === 0 && (
                                <TableRow key={1}>
                                  <TableCell colSpan={9} align="center">
                                    {ConfigETC.NoData}
                                  </TableCell>
                                </TableRow>
                              )) ||
                                listdata
                                  .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage
                                  )
                                  .map((row) => (
                                    <TableRow key={row.pro_id}>
                                      <TableCell>
                                        <div>{row.rowindex}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div className="text-bold">
                                          {row.pro_name}
                                        </div>
                                        
                                        {row.pro_start_date !=="" && row.pro_end_date !==""
                                        && (
                                        <div className="text-small">
                                          <span>
                                            Date:{row.pro_start_date} -{" "}
                                            {row.pro_end_date}
                                          </span>
                                        </div>) }

                                        <div className="text-small">
                                          <span>
                                            <span
                                              className={
                                                row.pro_status === 1
                                                  ? ConfigETC.Status_active
                                                  : ConfigETC.Status_inactive
                                              }
                                            >
                                              {row.pro_status_str}
                                            </span>
                                            &nbsp;
                                            {/*<span
                                              className={
                                                row.pro_is_close === 1
                                                  ? ConfigETC.Status_active
                                                  : ConfigETC.Status_inactive
                                              }
                                            >
                                              {row.pro_is_close_str}
                                            </span>*/}
                                          </span>
                                        </div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>{row.cus_name}</div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <span
                                          className="badge bg-gray text-biger"
                                          data-toggle="tooltip"
                                          title="department"
                                        >
                                          <i className="fas fa-cubes" />
                                          &nbsp;{row.dept_count_str}
                                        </span>{" "}
                                        <span
                                          className="badge bg-gray text-biger"
                                          data-toggle="tooltip"
                                          title="staffs"
                                        >
                                          <i className="fas fa-user" />
                                          &nbsp;{row.staff_count_str}
                                        </span>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>
                                          <span
                                            className="badge bg-gray text-biger"
                                            data-toggle="tooltip"
                                            title="task"
                                          >
                                            <i className="fas fa-tasks" />{" "}
                                            {row.task_count_str}
                                          </span>
                                        </div>
                                      </TableCell>
                                      <TableCell align="left">
                                        <div>
                                          <span>
                                            {row.work_time !== "" ? (
                                              <i className="fas fa-clock text-muted text-smaller" />
                                            ) : (
                                              ""
                                            )}
                                            &nbsp;{row.work_time}
                                          </span>
                                        </div>
                                      </TableCell>


                                      {isSVOT &&
                                        <TableCell align="left">
                                          <div>
                                            <span>
                                              {row.over_time !== "" ? (
                                                <i className="fas fa-clock text-muted text-smaller" />
                                              ) : (
                                                ""
                                              )}
                                              &nbsp;{row.over_time}
                                            </span>
                                          </div>
                                        </TableCell>
                                      }



                                      <TableCell align="left">
                                      <div>
                                          <span>
                                            {row.expense_str !== "0.00" && (
                                              <>
                                                <i className="fab fa-btc text-muted text-smaller" />
                                                {row.expense_str}
                                              </>
                                            )}
                                           
                                          </span>
                                        </div>
                                      </TableCell>
                                      <TableCell align="right">
                                        <div className="btn-group btn-group-sm">
                                          {isPermissionOverall && ( <Link
                                            to={"../" + Pathurl.m_project_view}
                                            state={{
                                              proid: Class_ETC_Encrypt(
                                                row.pro_id.toString()
                                              ),
                                              fromPage: Class_ETC_Encrypt(
                                                Pathurl.m_projectSearch
                                              ),
                                            }}
                                            data-toggle="tooltip"
                                            title="Click for view detail"
                                            className="btn bg-success btn-sm"
                                          >
                                            <i className="fas fa-tachometer-alt" />
                                          </Link>)}
                                         
                                          {(isPermissionEdit ||
                                            isPermissionview) && (
                                            <Link
                                              to={"../" + Pathurl.m_project_ae}
                                              state={{
                                                proid: Class_ETC_Encrypt(
                                                  row.pro_id.toString()
                                                ),
                                                act: ActEdit,
                                              }}
                                              data-toggle="tooltip"
                                              title="Click for edit"
                                              className="btn btn-primary btn-sm"
                                            >
                                              <i className="fas fa-pencil-alt" />
                                            </Link>
                                          )}
                                          {isPermissionDel && (
                                            <a
                                              href="#!"
                                              onClick={() =>
                                                onclick_DelProject(row.pro_id)
                                              }
                                              data-toggle="tooltip"
                                              title="Click for delete"
                                              className="btn btn-default btn-sm"
                                            >
                                              <i className="fas fa-trash" />
                                            </a>
                                          )}
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {listdata.length > 0 && (
                          <TablePagination
                            rowsPerPageOptions={[ConfigETC.rowsPerPage]}
                            component="div"
                            count={listdata.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={PaginationActions}
                          />
                        )}
                      </div>
                      {/* /.card-body */}
                    </div>
                    {/* /.card */}
                  </div>
                </div>
              </>
            )}
            
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
      {/* /.content-wrapper */}
    </>
  );
}
export default M_project_search;
